import { z } from 'zod'

const createCompanyFormSchema = z.object({
  nameKk: z.string().min(1, { message: 'Поле не может быть пустым' }),
  nameRu: z.string().min(1, { message: 'Поле не может быть пустым' }),
  bin: z
    .string()
    .min(12, { message: 'Неправильный формат. Убедитесь, что вы вводите правильные 12 цифр.' })
    .max(12, { message: 'Неправильный формат. Убедитесь, что вы вводите правильные 12 цифр.' }),
  companyTypeCode: z.string().min(1, { message: 'Поле не может быть пустым' }),
  katoId: z.string().uuid({ message: 'Поле не может быть пустым' }),
  code: z.string(),
})

export { createCompanyFormSchema }
